import Divider from "@mui/material/Divider";
import React from "react";
import { getFormattedAmount } from "../../../../../common/utils/methods/commonMethods/utilityMethod";
import { getPaymentModeName } from "../../components/constant";
import { getFormattedDate } from "../../../../../common/utils/methods/commonMethods/utilityMethod";

const cardInputStyles = {
  fontSize: "16px",
  border: "1px solid #E2E2E2",
  borderRadius: "8px",
  height: "44px",
  padding: "8px 12px",
  alignItems: "center",
  transition: "border 0.2s",
};

const labelStyles = {
  fontSize: "12px",
  marginBottom: "4px",
};

const cardContainerStyles = {
  backgroundColor: "#fff",
  borderRadius: "8px",
  padding: "16px",
};

const CardInput = ({ label, value }) => {
  return (
    <div
      className="d-flex flex-column flex-fill"
      style={{ minWidth: "173px", maxWidth: "253px" }}
    >
      <label className="text-bold" style={labelStyles}>
        {label}
      </label>
      <div className="text-bold d-flex" style={cardInputStyles}>
        {value || "-"}
      </div>
    </div>
  );
};

const DetailsCard = ({ epmrReceiptDetails }) => {
  const {
    paidAmount,
    epmrNumber,
    epmrCreationDate,
    emprConfirmationDate,
    epmrConfirmedBy,
    paymentMode,
    cardType,
    bankName,
    firstName,
    lastName,
    referenceNumber,
    paymentModeDate,
    chequeNumber,
    chequeDate
  } = epmrReceiptDetails;

  const isCheque = paymentMode ==="Cheque"||paymentMode=='CHKL';
  const isCreditCard = ["CC", "DB"].includes(paymentMode);

  return (
    <div style={cardContainerStyles}>
      <div className="d-flex gap-md" style={{ marginBottom: "16px" }}>
        <CardInput label="Amount" value={getFormattedAmount(paidAmount)} />
        <CardInput label="EPMR Number" value={epmrNumber} />
        <CardInput
          label="Payment Mode"
          value={getPaymentModeName(paymentMode)}
        />
      </div>
      <div className="d-flex gap-md">
        <CardInput
          label="Date Created"
          value={getFormattedDate(epmrCreationDate)}
        />
        <CardInput
          label="Date Confirmed"
          value={getFormattedDate(emprConfirmationDate)}
        />
        <CardInput label="Confirmed By" value={epmrConfirmedBy} />
      </div>
      {(isCheque || isCreditCard) && (
        <div className="mt-2">
          <Divider />
        </div>
      )}
      {(isCreditCard) && (
        <div className="text-bold text-dark my-2">Credit card details</div>
      )}
      {(isCheque) && (
        <div className="text-bold text-dark my-2">Cheque details</div>
      )}

      {isCheque && (
        <div className="d-flex gap-md">
          <CardInput label="Cheque Number" value= {referenceNumber} />
          <CardInput label="Bank" value= {bankName} />
          <CardInput label="Cheque date" value= {getFormattedDate(paymentModeDate)} />
        </div>
      )}

      {isCreditCard && (
        <div>
          <div className="d-flex gap-md" style={{ marginBottom: "16px" }}>
            <CardInput label="Card type" value={cardType} />
            <CardInput label="Bank" value={bankName} />
            <CardInput label="Last 4 digit" value= {`XXXX-${referenceNumber}`} />
          </div>
          <div className="d-flex gap-md">
            <CardInput label="First name" value={firstName} />
            <CardInput label="Last name" value={lastName} />
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailsCard;
